export function buildAddressOptions (source = []) {
  return source.map(province => ({
    text: province.name,
    value: province.name,
    children: (province.children || []).map(city => ({
      text: city.name,
      value: city.name,
      children: (city.children || []).map(area => ({
        text: area.name,
        value: area.name
      }))
    }))
  }))
}

export function getShippingStorageKey (sn) {
  return `bajie_aroma_shipping_${sn}`
}

export function readShipping (sn) {
  try {
    return JSON.parse(window.localStorage.getItem(getShippingStorageKey(sn)) || '{}')
  } catch (error) {
    return {}
  }
}

export function saveShipping (sn, shipping) {
  try {
    window.localStorage.setItem(getShippingStorageKey(sn), JSON.stringify(shipping))
  } catch (error) {
    // Storage can be unavailable in private browser modes.
  }
}

export function validateShipping (shipping = {}) {
  if (!shipping.receiverName?.trim()) return '请填写联系人'
  if (!shipping.receiverMobile?.trim()) return '请填写收货电话'
  if (!/^1\d{10}$/.test(shipping.receiverMobile.trim())) return '收货电话不正确'
  if (!Array.isArray(shipping.region) || shipping.region.length !== 3) return '请选择省市区'
  if (!shipping.receiverAddress?.trim()) return '请填写详细地址'
  return ''
}
